import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ModalInterface } from '../../modal.interface';
import { defer, forkJoin, merge, Observable, of, Subject } from 'rxjs';
import { ModalStateEvent } from '../../modal-state-event';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { ModalState } from '../../modal-state.enum';
import { MediaObjectRestService } from '../../../../api/services/media-object.rest.service';
import { MediaObjectApiModel } from '../../../../api/models/media-object.api-model';
import { filter, finalize, ignoreElements, map, mergeMap, take, tap } from 'rxjs/operators';
import { EventApiModel } from '../../../../api/models/event.api.model';
import { EventViewModel } from './event.view-model';
import { AddEventProviderService } from './add-event.provider.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { add, roundToNearestMinutes } from 'date-fns';
import { PostApiModel } from '../../../../api/models/post-api.model';
import { PostTypeEnum } from '../../../../core/enums/post-type.enum';
import { PostRestService } from '../../../../api/services/post-rest.service';
import { MapComponent } from '../../../map/map.component';
import { MapService } from '../../../map/map.service';
import { UserViewModel } from '../../../../features/user/settings/user.view-model';
import { TokenDataProviderService } from '../../../../core/services/token-data-provider.service';
import { CurrentUserViewModel } from '../../../../core/models/current-user.view-model';
import { LoaderService } from '../../../../core/services/loader.service';
import { ResponseErrorsHandlerService } from '../../../../core/services/response-errors-handler.service';
import { RemoveHtmlTagsPipe } from '../../../../core/pipes/remove-html-tags.pipe';
import { TranslateService } from "@ngx-translate/core";
import { HashtagValidator } from "../../../../core/validators/hashtag-validator";
import { AutoComplete, AutoCompleteSelectEvent } from "primeng/autocomplete";
import { ModalComponent } from "../../modal.component";
import { MediaUploadService } from "../../../../core/services/media-upload.service";
import { MediaObjectPipe } from "../../../../core/pipes/media-object.pipe";
import { FileUpload } from "primeng/fileupload";
import { QueryParamsApiModel } from "../../../../api/models/query-params-api.model";
import { ParticipantApiModel } from "../../../../api/models/participant.api.model";
import { FilterParameterApiModel } from "../../../../api/models/filter-parameter.api.model";
import { ResultListApiModel } from "../../../../api/models/result-list.api.model";
import { MediaUploaderComponent } from "../../../media/media-uploader/media-uploader.component";
import { MediaObjectViewModel } from "../../../../core/models/media-object.view-model";
import { FollowApiModel } from "../../../../api/models/follow.api-model";
import { UserApiModel } from "../../../../api/models/user.api-model";

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
  providers: [AddEventProviderService]
})
export class AddEventComponent implements ModalInterface, OnInit, AfterViewInit, OnDestroy {
  get searchText(): string {
    return this.form.get('addresses').value;
  }

  get eventDates(): UntypedFormArray {
    if (this.form) {
      return this.form.get('eventDates') as UntypedFormArray;
    }
  }

  public data: any;
  public parent?: ModalComponent;
  public subject: Subject<ModalStateEvent>;
  public state: Observable<ModalStateEvent>;
  public form: UntypedFormGroup;
  public image: any;
  public objectURL = '';
  public organizers: any[] = [];
  public invitedUsers: any[] = [];
  public followers: any[] = [];
  public isLoadingFollowers = false;
  public showVisibilityEditor = false;
  public visibilityOptions: SelectItem[] = [];
  public options: any;
  public eventVM: EventViewModel;
  public eventAM: EventApiModel;
  public currentUserVM: CurrentUserViewModel;
  searchResults: SelectItem[] = [];
  public files: File[] = [];
  public disabled = false;
  public mediaProgress?: number;

  public mediaObjectAMs: MediaObjectApiModel[] = [];
  @ViewChild(MapComponent) public mapComponent: MapComponent;
  @ViewChild('coverUploader') public coverUploader: FileUpload;
  @ViewChild('mediaUploaderComponent') public mediaUploaderComponent: MediaUploaderComponent;
  @ViewChildren(AutoComplete)
  private queryList: QueryList<AutoComplete>;

  // @ViewChild(GMap) gmap: GMap;

  constructor(
    private readonly fb: RxFormBuilder,
    private readonly renderer: Renderer2,
    private readonly mediaObjectRS: MediaObjectRestService,
    public readonly eventPS: AddEventProviderService,
    private readonly postRS: PostRestService,
    private readonly mapService: MapService,
    private readonly tokenDP: TokenDataProviderService,
    private readonly ls: LoaderService,
    private readonly reh: ResponseErrorsHandlerService,
    private readonly translator: TranslateService,
    private readonly mediaUploadService: MediaUploadService,
    private readonly confirmationService: ConfirmationService,
  ) {
  }

  public ngOnInit() {
    this.parent.proceedButtonBadge = null;
    this.parent.progress = null;
    this.parent.loading = false;
    this.eventAM = this.data.eventAM;
    this.createForm();
    this.buildVisibilityOptions();
    this.state.subscribe((mse: ModalStateEvent) => {
      switch (mse.status) {
        case ModalState.PENDING:
          this.submit();
      }
    });

    this.tokenDP.currentUser.subscribe((user: CurrentUserViewModel) => {
      this.currentUserVM = user;
      this.organizers.push(this.eventPS.createUserInterface(user));
      this.loadFollowers();
    });

    this.eventPS.fetchResourcesFromQuerySubject(email => this.eventPS.findInvitationCandidate(email)).subscribe();
  }

  ngAfterViewInit(): void {
    this.mediaUploadService.convertUrlToFile(this.eventAM?.cover ? [MediaObjectPipe.transformToLink(this.eventAM.cover as MediaObjectApiModel, {
      formatType: 'original',
      defaultImageType: 'background'
    })] : []).subscribe(files => {
      if (files.length) {
        this.coverUploader.files = files;
        this.onUpload({ files }, 'single');
      }
    });
    this.queryList.forEach((e: AutoComplete) => {
      e.el.nativeElement.removeAttribute('pautofocus');
      e.inputEL?.nativeElement.removeAttribute('pautofocus');
    });
    this.mediaUploaderComponent.selectMedia(this.mediaUploaderComponent.fileUploader);
  }

  ngOnDestroy(): void {
    this.eventAM = null;
  }

  private createForm() {
    const namesValidators = [
      RxwebValidators.required(),
      RxwebValidators.minLength({ value: 2 }),
      RxwebValidators.maxLength({ value: 255 })
    ];
    const searchValidators = [
      RxwebValidators.required(),
      RxwebValidators.minLength({ value: 2 }),
    ];

    this.form = this.fb.group({
      cover: [null],
      name: [null, namesValidators],
      description: ['', [RxwebValidators.minLength({ value: 2 }), RxwebValidators.maxLength({ value: 65000 })]],
      addresses: [null, searchValidators],
      eventDates: new UntypedFormArray([this.createEventDateGroup()], [RxwebValidators.choice({ minLength: 1 })]),
      organizers: new UntypedFormControl({ value: [], disabled: false }),
      visibility: new UntypedFormControl(this.eventAM?.visibility ?? 'PUBLIC'),
      invitedUsers: new UntypedFormControl({ value: [], disabled: false }),
      hashtags: new UntypedFormControl({
        value: [],
        disabled: false
      }, [HashtagValidator.maxHashtags(10, this.translator), HashtagValidator.uniqueHashtags(this.translator)]),
      metaTitle: [null],
      metaKeywords: [null],
      metaDescription: [null],
    });

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.subject.next(new ModalStateEvent(ModalState.VALID));
      } else {
        // this.subject.next(new ModalStateEvent(ModalState.INVALID));
      }
    });

    if (this.eventAM?.id) {
      this.parent.name = this.translator.instant('common.update') + ' ' + this.eventAM.name
      this.form.patchValue({
        ...this.eventAM,
        organizers: [],
      });
      if (this.eventAM.invitations?.length) {
        this.invitedUsers = this.eventAM.invitations
          .map(invitation => invitation.invitedUser)
          .filter((invitedUser: any) => typeof invitedUser === 'object' && invitedUser !== null)
          .map((invitedUser: UserApiModel) => this.eventPS.createUserInterface(new UserViewModel(invitedUser)));
        this.form.patchValue({ invitedUsers: this.invitedUsers });
      }

      if (this.eventAM.addresses?.length) {
        const coordinates = this.eventAM.addresses[0]['coordinates'];
        this.mapService.reverseGeocode(coordinates[0], coordinates[1]).subscribe((reverseGeocodeRes: any) => {
          this.searchResults = [{ label: reverseGeocodeRes.display_name, value: reverseGeocodeRes }];
          this.form.patchValue({ addresses: this.searchResults });
        });
      }
    } else {
      this.parent.name = this.translator.instant('shared.modal.modal_service.add_event.title');
    }

    if (this.eventAM.organizers?.length) {
      const queryParams = new QueryParamsApiModel();
      queryParams.pagination = false;
      (this.eventAM.organizers as Array<ParticipantApiModel | string>).forEach((organizer) => {
        if (typeof organizer === 'string') {
          const slug = organizer.split('/').pop();
          if (slug) {
            queryParams.filters.push(new FilterParameterApiModel('slug', slug, 'array'));
          }
          return;
        }
        const data = organizer?.data as any;
        const slug = typeof data === 'string'
          ? data.split('/').pop()
          : (data?.slug || data?.['@id']?.split('/').pop());
        if (slug) {
          queryParams.filters.push(new FilterParameterApiModel('slug', slug, 'array'));
        }
      });
      if (!queryParams.filters.length) {
        return;
      }
      this.eventPS.fetchUsers(queryParams).subscribe(([users]: UserViewModel[][]) => {
        if (!users.length) {
          return;
        }
        this.organizers = [...users.map(u => {
          return this.eventPS.createUserInterface(u);
        })]
      });
    }

    if (this.eventAM.eventDates?.length) {
      this.createEventDateGroupFromEventAM(this.eventAM.eventDates);
    }

    if (this.eventAM.posts?.length) {
      this.postRS.getEventSubResourceCollection(this.eventAM['@id']).subscribe((resultListAM: ResultListApiModel<PostApiModel>) => {
        this.mediaUploaderComponent.mediaObjectAMs = resultListAM.records.filter(postAM => postAM.type === PostTypeEnum.EVENT_MEDIA_POST).flatMap(e => e.media as MediaObjectApiModel[]);
        this.mediaUploaderComponent.selectMedia(this.mediaUploaderComponent.fileUploader);
      })
    }


    return this.form;
  }

  private buildVisibilityOptions(): void {
    this.visibilityOptions = [
      { label: this.translator.instant('shared.modal.modal_service.add_event.visibility_public'), value: 'PUBLIC' },
      { label: this.translator.instant('shared.modal.modal_service.add_event.visibility_closed'), value: 'CLOSED' }
    ];
  }

  private loadFollowers(): void {
    if (!this.currentUserVM?.['@id']) {
      return;
    }
    const queryParams = new QueryParamsApiModel();
    queryParams.pagination = false;
    this.isLoadingFollowers = true;
    this.eventPS.userRS.getReceivedFollowsSubResourceCollection(this.currentUserVM['@id'], queryParams).subscribe({
      next: (resultListAM) => {
        const followedByObjects = resultListAM.records
          .map((follow: FollowApiModel) => follow.followedBy)
          .filter((followedBy: any) => typeof followedBy === 'object' && followedBy !== null) as UserApiModel[];

        const objectFollowers = followedByObjects
          .map((followedBy: UserApiModel) => this.eventPS.createUserInterface(new UserViewModel(followedBy)));

        const followedBySlugs = resultListAM.records
          .map((follow: FollowApiModel) => follow.followedBy)
          .filter((followedBy: any) => typeof followedBy === 'string')
          .map((followedBy: string) => followedBy.split('/').pop())
          .filter((slug: string) => !!slug);

        if (!followedBySlugs.length) {
          this.followers = objectFollowers;
          return;
        }

        const usersQuery = new QueryParamsApiModel();
        usersQuery.pagination = false;
        usersQuery.filters = followedBySlugs.map(slug => new FilterParameterApiModel('slug', slug, 'array'));
        this.eventPS.fetchUsers(usersQuery).subscribe({
          next: ([users]: UserViewModel[][]) => {
            const fetchedFollowers = users.map(u => this.eventPS.createUserInterface(u));
            this.followers = [...objectFollowers, ...fetchedFollowers];
          },
          error: () => {
            this.followers = objectFollowers;
          }
        });
      },
      error: () => {
        this.followers = [];
      }
    }).add(() => {
      this.isLoadingFollowers = false;
    });
  }

  createEventDateGroup(): UntypedFormGroup {
    const timeStart = roundToNearestMinutes(new Date(), { nearestTo: 15 });
    return this.fb.group({
      name: new UntypedFormControl('', [
        RxwebValidators.minLength({ value: 2 }),
        RxwebValidators.maxLength({ value: 255 }),
      ]),
      date: new UntypedFormControl(add(timeStart, { days: 1 }), [RxwebValidators.date()]),
      from: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
      to: new UntypedFormControl(add(timeStart, { hours: 1 }), [RxwebValidators.date()])
    });
  }

  createEventDateGroupFromEventAM(eventDates: any[]): void {
    eventDates.forEach((eventDate) => {
      const timeStart = new Date(eventDate.start);
      const timeEnd = new Date(eventDate.end);
      this.eventDates.removeAt(0);
      this.eventDates.push(this.fb.group({
        name: new UntypedFormControl(eventDate.name, [
          RxwebValidators.minLength({ value: 2 }),
          RxwebValidators.maxLength({ value: 255 }),
        ]),
        date: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
        from: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
        to: new UntypedFormControl(timeEnd, [RxwebValidators.date()])
      }));
    });

  }

  public toggleCopyValuesToMetaTags(event: { checked: boolean }): void {
    if (event.checked) {
      this.copyValue(this.form, 'name', 'metaTitle');
      this.copyValue(this.form, 'description', 'metaDescription');
    } else {
      this.form.get('metaTitle').reset();
      this.form.get('metaKeywords').reset();
      this.form.get('metaDescription').reset();
    }
  }

  public copyValue(form: UntypedFormGroup, copyFromFieldName: string, subscribingFormFieldName: string): void {
    const field = form.get(subscribingFormFieldName);
    field.setValue(RemoveHtmlTagsPipe.sanitize(form.get(copyFromFieldName).value));
  }

  addDate(): void {
    const group = this.createEventDateGroup();
    this.eventDates.push(group);
  }

  removeDate(): void {
    if (this.eventDates.length > 1) {
      this.eventDates.removeAt(this.eventDates.length - 1);
    }
  }

  onUpload(event: any, type: 'single' | 'multiple') {
    this.openMediaBox();
    switch (type) {
      case 'single':
        const file = event.files[0];
        file.objectURL = file.objectURL ? file.objectURL : this.objectURL;
        if (!file.objectURL) {
          return;
        } else {
          this.image = file;
          this.objectURL = file.objectURL;
          console.log(this.objectURL, this.image);
        }
        break;
      case 'multiple':
        // this.form.get('images').setValue(event.files);
        break;
    }

  }

  removeImage() {
    this.image = null;
  }

  public openMediaBox(): void {
    setTimeout(() => {
      const elements = document.querySelectorAll('.p-fileupload-row button');
      elements.forEach((e) => {
        this.renderer.addClass(e, 'p-button-text');
      });
    }, 1);
  }

  // addMedia(files: File[]): Observable<any> {
  //   this.disabled = true;
  //   const requests: Observable<PostApiModel>[] = [];
  //   files.forEach((file: File) => {
  //     if (!this.mediaObjectAMs.find((e: MediaObjectApiModel) => {
  //       return e.name === file.name;
  //     })) {
  //       const req = this.postMediaObject(file).pipe(mergeMap((mediaObjectAM: MediaObjectApiModel) => {
  //         const postAM = new PostApiModel();
  //         postAM.media = [];
  //         postAM.media.push(mediaObjectAM['@id']);
  //         postAM.event = this.eventVM['@id'];
  //         postAM.type = PostTypeEnum.EVENT_MEDIA_POST;
  //         postAM.content = '';
  //         return this.postRS.create(postAM);
  //       }));
  //       requests.push(req);
  //     }
  //   });
  //
  //   if (!requests.length) {
  //     return of([]);
  //   }
  //
  //   return defer(() => {
  //     let counter = 0;
  //     const percent$ = new Subject();
  //
  //     const modifiedObservablesList = requests.map(
  //       (item, index) => item.pipe(
  //         finalize(() => {
  //           const percentValue = ++counter * 100 / requests.length;
  //           percent$.next(percentValue);
  //         })
  //       )
  //     );
  //
  //     const finalResult$ = forkJoin(modifiedObservablesList).pipe(
  //       tap(() => {
  //           percent$.next(100);
  //           percent$.complete();
  //         }
  //       ));
  //
  //     return of([finalResult$, percent$.asObservable()]);
  //   }).pipe(
  //     mergeMap(([finalResult, progress]) => merge(
  //       progress.pipe(
  //         tap((value: number) => this.mediaProgress = value),
  //         ignoreElements()
  //       ),
  //       finalResult
  //     ))
  //   );
  // }

  // public submit(): void {
  //   console.log(this.form);
  //   if (this.form.valid) {
  //     if (!this.eventAM?.id) {
  //       this.eventVM = this.form.value;
  //       this.eventVM.apiModel = new EventApiModel();
  //       this.eventVM.organizers = this.organizers;
  //       this.eventVM.hashtags = this.form.get('hashtags').value.length ? this.form.get('hashtags').value : [];
  //       this.eventVM.posts = [];
  //     } else {
  //       this.eventVM = {...this.data.eventAM, ...this.form.value};
  //       this.eventVM.organizers = this.organizers;
  //     }
  //
  //     const files = this.mediaUploaderComponent.newFiles;
  //     this.mediaUploadService.uploadMedia(files)
  //       .pipe(mergeMap(({mediaObjects$, progress$}) => {
  //         progress$.subscribe((progress) => {
  //           this.parent.progress = progress; // Aktualizacja procentowego postępu
  //         });
  //
  //         return mediaObjects$.pipe(mergeMap((uploadedMedia: MediaObjectApiModel[]) => {
  //           const requests: Observable<PostApiModel>[] = [];
  //           uploadedMedia.forEach(mediaObjectAM => {
  //             const postAM = new PostApiModel();
  //             postAM.media = [];
  //             postAM.media.push(mediaObjectAM['@id']);
  //             postAM.event = this.eventVM['@id'];
  //             postAM.type = PostTypeEnum.EVENT_MEDIA_POST;
  //             postAM.content = '';
  //             requests.push(this.postRS.create(postAM));
  //           })
  //
  //           return requests.length ? forkJoin(requests) : of([]);
  //         }));
  //       }))
  //       .pipe(mergeMap((uploadedMediaPosts: PostApiModel[]) => {
  //         return this.image && this.image.name !== this.eventVM.cover.name ? this.mediaObjectRS.uploadImage(this.image).pipe(mergeMap((mediaObjectAM: MediaObjectApiModel) => {
  //           return of([uploadedMediaPosts, mediaObjectAM]);
  //         })) : of([uploadedMediaPosts, null]);
  //       }))
  //       .pipe(mergeMap(([uploadedMediaPosts, cover]: [PostApiModel[], MediaObjectApiModel]) => {
  //         console.log(uploadedMediaPosts);
  //         const newMedia = uploadedMediaPosts.map((postAM: PostApiModel) => postAM.media[0]);
  //         const existingMedia = this.mediaUploaderComponent.mediaObjectAMs.map(m => m['@id']) as string[];
  //         if (cover) {
  //           this.eventVM.cover = new MediaObjectViewModel(cover);
  //         }
  //         this.eventVM.media = [...existingMedia, ...newMedia];
  //         this.eventVM.posts = [...this.eventVM.posts, ...uploadedMediaPosts];
  //
  //         return !this.eventAM?.id ? this.eventPS.createEvent(this.eventVM) : this.eventPS.updateEvent(this.eventVM);
  //       }))
  //       .subscribe({
  //         next: (eventAM: EventApiModel) => {
  //           this.subject.next(new ModalStateEvent(ModalState.SUCCESS, eventAM));
  //
  //           this.form.reset({
  //             heading: null,
  //             dateRange: null,
  //             content: null,
  //           });
  //           this.form.markAsPristine();
  //           this.form.markAsUntouched();
  //           this.form.updateValueAndValidity();
  //           this.parent.loading = false;
  //         },
  //         error: (errorResponse) => {
  //           this.parent.progress = null;
  //
  //           this.eventVM = null;
  //           this.ls.hide();
  //           this.reh.handleFormErrors(this.form, errorResponse);
  //           this.parent.loading = false;
  //         }
  //       });
  //   } else {
  //     this.ls.hide();
  //     this.form.markAllAsTouched();
  //     this.parent.loading = false;
  //   }
  // }

  public submit(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.parent.loading = false;
      return;
    }

    this.parent.loading = true;

    // ===== EVENT VM INIT =====
    if (!this.eventAM?.id) {
      this.eventVM = {
        ...this.form.value,
        apiModel: new EventApiModel(),
        organizers: this.organizers,
        invitedUsers: this.invitedUsers,
        hashtags: this.form.get('hashtags')?.value ?? [],
        posts: [],
      };
    } else {
      this.eventVM = {
        ...this.data.eventAM,
        ...this.form.value,
        organizers: this.organizers,
        invitedUsers: this.invitedUsers,
      };
    }

    const files = this.mediaUploaderComponent.newFiles;

    this.mediaUploadService
      .uploadMedia(files)
      .pipe(
        // ===== PROGRESS =====
        tap(({ progress$ }) => {
          progress$.subscribe(progress => {
            this.parent.progress = progress;
          });
        }),

        // ===== WAIT FOR UPLOADS =====
        mergeMap(({ mediaObjects$ }) => mediaObjects$),

        // ===== CREATE POSTS =====
        mergeMap((uploadedMedia: MediaObjectApiModel[]) => {
          if (!uploadedMedia.length) {
            return of<PostApiModel[]>([]);
          }

          const requests = uploadedMedia.map(media => {
            const post = new PostApiModel();
            post.media = [media['@id']];
            post.event = this.eventVM['@id'];
            post.type = PostTypeEnum.EVENT_MEDIA_POST;
            post.content = '';
            return this.postRS.create(post);
          });

          return forkJoin(requests);
        }),

        // ===== OPTIONAL COVER UPLOAD =====
        mergeMap((posts: PostApiModel[]) => {
          const shouldUploadCover =
            this.image &&
            this.image.name !== this.eventVM.cover?.name;

          if (!shouldUploadCover) {
            return of<[PostApiModel[], MediaObjectApiModel | null]>([
              posts,
              null,
            ]);
          }

          return this.mediaObjectRS.uploadImage(this.image).pipe(
            filter(
              (v): v is MediaObjectApiModel => typeof v !== 'number'
            ),
            take(1),
            map(
              (cover): [PostApiModel[], MediaObjectApiModel] => [
                posts,
                cover,
              ]
            )
          );
        }),

        // ===== FINAL EVENT SAVE =====
        mergeMap(
          ([posts, cover]: [
            PostApiModel[],
            MediaObjectApiModel | null
          ]) => {
            if (cover) {
              this.eventVM.cover = new MediaObjectViewModel(cover);
            }

            const newMedia = posts.map(p => p.media[0]);
            const existingMedia =
              this.mediaUploaderComponent.mediaObjectAMs.map(
                m => m['@id']
              );

            this.eventVM.media = [...existingMedia, ...newMedia];
            this.eventVM.posts = [...this.eventVM.posts, ...posts];

            return this.eventAM?.id
              ? this.eventPS.updateEvent(this.eventVM)
              : this.eventPS.createEvent(this.eventVM);
          }
        )
      )
      .subscribe({
        next: (eventAM: EventApiModel) => {
          this.subject.next(
            new ModalStateEvent(ModalState.SUCCESS, eventAM)
          );

          this.form.reset({
            heading: null,
            dateRange: null,
            content: null,
          });

          this.form.markAsPristine();
          this.form.markAsUntouched();
          this.form.updateValueAndValidity();

          this.parent.progress = null;
          this.parent.loading = false;
        },
        error: errorResponse => {
          this.parent.progress = null;
          this.parent.loading = false;
          this.reh.handleFormErrors(this.form, errorResponse);
        },
      });
  }

  searchPlaces(event: any) {
    const sub = this.mapService.subscribeToQuerySubject().subscribe((results: any[]) => {
      this.searchResults = results.map(result => ({ label: result.display_name, value: result }));
      if (!this.searchResults.length) {
        this.form.get('addresses').setErrors({ incorrect: true, message: 'This is not valid place' });
      }
      sub.unsubscribe();
    });
    this.mapService.searchPlaces(event.query);
  }

  selectPlace(event: AutoCompleteSelectEvent) {
    const item: any = event.value.value;
    const iMarker = { lat: item.lat as number, lon: item.lon as number };

    if (this.mapComponent.layerMarkers.length) {
      this.mapComponent.removeMarker(this.mapComponent.layerMarkers[this.mapComponent.layerMarkers.length - 1]);
    }
    this.mapComponent.addMarker(iMarker);
    this.mapComponent.updateMapCenter(iMarker);
    const addrInput = this.form.get('addresses');
    addrInput.setValue([event.value]);

    // addrInput.setValue(event.value);
    addrInput.setErrors(null);
  }

  emitQuery(queryEvt) {
    const query = String(queryEvt.query || '').trim();
    this.eventPS.resultSubject$.next(query);
  }

  addOrganizer(item: any, autocomplete: AutoComplete) {
    if (this.organizers.find(e => e.alias === item.alias)) {
      return;
    }

    this.organizers.push(item);
    autocomplete.writeValue(null);
  }

  removeOrganizer(item: any) {
    this.organizers = this.organizers.filter(e => e.alias !== item.alias);
  }

  public toggleVisibilityEditor(): void {
    this.showVisibilityEditor = !this.showVisibilityEditor;
  }

  public onVisibilityChange(value: string): void {
    if (value === 'PUBLIC') {
      this.invitedUsers = [];
      this.form.get('invitedUsers').setValue([]);
    }
  }

  addInvitedUser(item: any, autocomplete: AutoComplete): void {
    if (this.invitedUsers.find(e => e.alias === item.alias)) {
      return;
    }
    if (this.currentUserVM?.id && item.id === this.currentUserVM.id) {
      return;
    }
    if (this.organizers.find(e => e.id === item.id)) {
      return;
    }

    this.invitedUsers.push(item);
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
    autocomplete.writeValue(null);
  }

  removeInvitedUser(item: any): void {
    this.invitedUsers = this.invitedUsers.filter(e => e.alias !== item.alias);
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
  }

  addFollowersToInvited(): void {
    if (!this.followers?.length) {
      return;
    }
    const existingIds = new Set(this.invitedUsers.map(u => u.id));
    this.followers.forEach(follower => {
      if (this.currentUserVM?.id && follower.id === this.currentUserVM.id) {
        return;
      }
      if (this.organizers.find(e => e.id === follower.id)) {
        return;
      }
      if (!existingIds.has(follower.id)) {
        this.invitedUsers.push(follower);
      }
    });
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
  }

  getAddrOptionValue(item: SelectItem): any {
    return item.value;
  }

  getAddrOptionLabel(item: SelectItem): any {
    return item.label;
  }

  public beforeModalCloseAttempt(): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translator.instant('shared.modal.modal_service.add_event.exit_process_title'),
        message: this.translator.instant('shared.modal.modal_service.add_event.exit_process_message'),
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
